import Sidebar from "@/components/sidebar/Sidebar";
import { ScrollArea } from "@/components/ui/scroll-area";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_organization-access/_overlay-sidebar"
)({
  component: OverlaySidebar
});

function OverlaySidebar() {
  return (
    <ScrollArea className="relative dark:bg-brand-gray-950 bg-white w-full h-screen">
      <div className="z-10 absolute left-1.5 top-auto bottom-1.5 flex items-end">
        <Sidebar canMinimize />
      </div>
      <div className="h-screen w-full">
        <Outlet />
      </div>
    </ScrollArea>
  );
}
